//禁止微信自定义字体大小
(function () {

    if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {

        handleFontSize();

    } else {
        if (document.addEventListener) {

            document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);

        } else if (document.attachEvent) {

            document.attachEvent("WeixinJSBridgeReady", handleFontSize);

            document.attachEvent("onWeixinJSBridgeReady", handleFontSize);

        }

    }

    function handleFontSize() {

        // 设置网页字体为默认大小
        WeixinJSBridge.invoke('setFontSizeCallback', {

            'fontSize': 0

        });


        // 重写设置网页字体大小的事件
        WeixinJSBridge.on('menu:setfont', function () {

            WeixinJSBridge.invoke('setFontSizeCallback', {

                'fontSize': 0

            });

        });

    }
})();

//1rem = 40px,html font-size:10px
window.addEventListener(('orientationchange' in window ? 'orientationchange' : 'resize'), (function() {
	function c() {
	  var d = document.documentElement;
	  var cw = d.clientWidth || 750;
	  d.style.fontSize = (20 * (cw / 375)) > 40 ? 40 + 'px' : (20 * (cw / 375)) + 'px';
	  if(document.getElementById('load')){
		document.getElementById('load').style.display="none";
	  }
	}
	c();
    return c;
})(), false);

